import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classnames';
import FluidImage from '@utility/FluidImage/index';
import Parallax from '@utility/Parallax';
import ScrollInView from '@utility/ScrollInView/index';
import Link from '@utility/Link/index';
import * as styles from './styles';
import ContentWithSuperscript from '../CollectionTitle';

const ImageText = ({
  data: { subheading, heading, details, reverse, paragraph, link, image },
}) => (
  <ScrollInView className={styles.imageText}>
    <div className={`${styles.imageTextInner}`}>
      <Parallax
        y={[-15, 15]}
        className={cn(styles.imageTextImage, {
          [styles.imageTextImageReverse]: reverse,
        })}
      >
        <FluidImage
          src={image}
          maxWidth={2400}
          maxHeight={1754}
          aspectRatio={1}
        />
      </Parallax>
      <div className="wrapper">
        <div className="row">
          <div
            className={`col-12 lg:col-5 ${
              reverse ? 'lg:offset-6' : ' lg:offset-1'
            }`}
          >
            {heading && (
              <div className="pt-8 lg:pt-20 mb-4 lg:mb-8">
                {/* {subheading && (
                  <p className="type-upper-070 text-mono-400 mt-1 mb-2">
                    {subheading}
                  </p>
                )} */}
                <h2 className="type-sans-730 lg:type-sans-930"><ContentWithSuperscript content={heading} /></h2>
                {details && <p className="type-sans-230"><ContentWithSuperscript content={details} /></p>}
              </div>
            )}
            {paragraph && (
              <p className={styles.imageTextParagraph}>{paragraph}</p>
            )}
            {link && (
              <div>
                {link.map((el) => (
                  <p key={el._key} className="type-sans-030 mt-8 lg:mt-12">
                    <Link internalExternal to={el} aria-label={el.label}>
                      <ContentWithSuperscript content={el.label}/>
                    </Link>
                  </p>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  </ScrollInView>
);

ImageText.propTypes = {
  data: PropTypes.shape({
    image: PropTypes.object.isRequired,
    subheading: PropTypes.string,
    details: PropTypes.string,
    heading: PropTypes.string,
    paragraph: PropTypes.string.isRequired,
    reverse: PropTypes.bool,
    link: PropTypes.arrayOf(PropTypes.object),
  }),
};

ImageText.defaultProps = {
  data: {
    heading: '',
    paragraph: '',
    subheading: '',
    orientation: 'normal',
    link: [],
    reverse: false,
  },
};

export default ImageText;
